"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var QUALIFICATION_CONFIG_PATH = '/ai/config/qualification';
/**
 * Defensive shape check for the qualification-config payload returned by the
 * backend. We only require the three top-level arrays the editor consumes;
 * additional fields are passed through untouched.
 */
var isQualificationConfigShape = function (value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return false;
    }
    var candidate = value;
    return (Array.isArray(candidate.systems) &&
        Array.isArray(candidate.workflows) &&
        Array.isArray(candidate.fields));
};
/**
 * API service for AI Hub data sources, backed by the qualification-config
 * endpoint (`/ai/config/qualification`).
 */
var aiHubSettingsApiService = {
    /**
     * Fetch the current qualification configuration.
     */
    getConfiguration: function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet(QUALIFICATION_CONFIG_PATH)];
                case 1:
                    result = _b.sent();
                    // Empty array is the helpers-sales transport-failure sentinel.
                    if (!result || (Array.isArray(result) && result.length === 0)) {
                        throw new Error('Empty or invalid response from data sources API');
                    }
                    if (!isQualificationConfigShape(result)) {
                        throw new Error('Malformed qualification configuration payload');
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_1 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error fetching AI Hub qualification configuration:', (_a = error_1) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    /**
     * Persist the current qualification configuration. The backend PUT echoes
     * the saved config; we synthesize a `WsAiHubSettingsSaveResponse` envelope
     * for the UI status banner.
     */
    saveConfiguration: function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPut, result, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    apiPut = config_1.getApiPut();
                    return [4 /*yield*/, apiPut(QUALIFICATION_CONFIG_PATH, config)];
                case 1:
                    result = _b.sent();
                    if (!result || (Array.isArray(result) && result.length === 0)) {
                        throw new Error('Empty or invalid response from data sources save API');
                    }
                    return [2 /*return*/, {
                            success: true,
                            message: 'Settings saved successfully',
                            receivedAt: new Date().toISOString(),
                        }];
                case 2:
                    error_2 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error saving AI Hub qualification configuration:', (_a = error_2) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); },
};
exports.default = aiHubSettingsApiService;
